import { Button, Modal } from "react-bootstrap";
import {
  MascotaReporteDiario,
  ReporteDiario,
  useBuscarReporteDiario,
} from "../../../services/reporteDiarioServicios";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import LoadingScreen from "../../organisms/LoadingScreen";

function VerReporteModal({
  mascota,
  onCloseClick,
  onEditarReporteClick,
}: {
  mascota: MascotaReporteDiario;
  onEditarReporteClick: (
    mascota: MascotaReporteDiario,
    reporteDiario: ReporteDiario
  ) => void;
  onCloseClick: () => void;
}) {
  const {
    data: reporteDiario,
    isLoading: reporteDiarioIsLoading,
    error: reporteDiarioError,
  } = useBuscarReporteDiario(mascota.idAsistencia);

  const esEditable = mascota.estado === "REPORTE_CREADO";
  const onEditarClick = () => {
    onEditarReporteClick(mascota, reporteDiario!);
  };

  if (reporteDiarioError) {
    return <ServerErrorModal onClose={onCloseClick} />;
  }

  if (reporteDiarioIsLoading) {
    return <LoadingScreen />;
  }

  const hayNovedades =
    reporteDiario?.novedades ||
    reporteDiario?.fotoNovedades ||
    reporteDiario?.videoNovedades;

  return (
    <Modal show={true}>
      <Modal.Header className="d-flex justify-content-center">
        <h4 className="text-center">Visualización de reporte diario</h4>
      </Modal.Header>
      <Modal.Body>
        <section className="d-flex flex-column gap-4">
          <section className="d-flex flex-column">
            <h5>
              <strong>Datos de mascota</strong>
            </h5>
            {reporteDiario?.fotoGeneral && (
              <>
                <div className="mb-2">Foto general:</div>
                <img src={reporteDiario.fotoGeneral} width="250" alt="" />
              </>
            )}
            <div className="mt-3">
              <p>
                <span>Nombre: </span>
                <i>{mascota.nombreMascota}</i>
              </p>
              <p>
                Propietario: <i>{mascota.nombrePropietario}</i>
              </p>
            </div>
          </section>
          <section className="d-flex flex-column">
            <h5>
              <strong>Alimentación</strong>
            </h5>
            <div className="mt-2">
              {reporteDiario?.desayuno !== null && (
                <p>
                  <span>Desayunó:</span>{" "}
                  <i>{reporteDiario?.desayuno ? "Si" : "No"}</i>
                </p>
              )}

              {reporteDiario?.almorzo !== null && (
                <p>
                  <span>Almorzó:</span>{" "}
                  <i>{reporteDiario?.almorzo ? "Si" : "No"}</i>
                </p>
              )}

              {reporteDiario?.ceno !== null && (
                <p>
                  <span>Cenó:</span> <i>{reporteDiario?.ceno ? "Si" : "No"}</i>
                </p>
              )}
            </div>
            {reporteDiario?.observacionesAlimenticias && (
              <div>
                <div>Observaciones alimenticias:</div>
                <small>{reporteDiario?.observacionesAlimenticias}</small>
              </div>
            )}
          </section>
          <section className="d-flex flex-column">
            <h5>
              <strong>Salud</strong>
            </h5>
            <div className="mt-2">
              {reporteDiario?.tomoMedicamentos !== null && (
                <p>
                  <span>Tomó medicamentos:</span>{" "}
                  <i>{reporteDiario?.tomoMedicamentos ? "Si" : "No"}</i>
                </p>
              )}

              {reporteDiario?.observacionesMedicas && (
                <div>
                  <div>Observaciones médicas:</div>
                  <small>{reporteDiario?.observacionesMedicas}</small>
                </div>
              )}
            </div>
          </section>
          <section className="d-flex flex-column">
            <h5>
              <strong>Comportamiento</strong>
            </h5>
            <div className="mt-2">
              <p>
                <span>Temperamento:</span> <i>{reporteDiario?.temperamento}</i>
              </p>
              <p>
                <span>Estado de ánimo:</span>{" "}
                <i>{reporteDiario?.estadoAnimo}</i>
              </p>
              {reporteDiario?.observacionesSocializacion && (
                <div className="mb-3">
                  <div>Observaciones de socialización:</div>
                  <small>{reporteDiario?.observacionesSocializacion}</small>
                </div>
              )}
            </div>
          </section>
          {hayNovedades && (
            <section className="d-flex flex-column">
              <h5>
                <strong>Novedades</strong>
              </h5>
              <div className="mt-2 d-flex flex-column gap-2">
                {reporteDiario?.novedades && (
                  <div>
                    <div>Novedades:</div>
                    <small>{reporteDiario.novedades}</small>
                  </div>
                )}
                {reporteDiario?.fotoNovedades && (
                  <>
                    <div>Foto de novedades:</div>
                    <img src={reporteDiario.fotoNovedades} width="250" alt="" />
                  </>
                )}
                {reporteDiario?.videoNovedades && (
                  <>
                    <div>Video de novedades:</div>
                    <video width="250" controls>
                      <source src={reporteDiario.videoNovedades} />
                    </video>
                  </>
                )}
              </div>
            </section>
          )}
        </section>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2">
          {esEditable && (
            <Button variant="primary" onClick={onEditarClick}>
              Editar
            </Button>
          )}
          <Button variant="danger" onClick={onCloseClick}>
            Cerrar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default VerReporteModal;
